module.exports = __webpack_public_path__ + "static/media/frame.d0ace889.svg";